import { BoxProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'
import { Colors } from '../../util/util'

export const styles = {
  container: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: Colors.LIGHT_GREY,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.BORDER_COLOR,
    zIndex: 10,
    flex: 1,
    height: '100%',
    marginVertical: 16,
    marginHorizontal: 16,
    backgroundColor: 'WHITE',
    paddingHorizontal: 16,
    width: '96%',
    alignSelf: 'center',
    paddingVertical: 16,
  } as BoxProps,
  inputContainer: {
    flex: 0.5,
    alignItems: 'center',
    backgroundColor: 'red',
    justifyContent: 'space-around',
    alignContent: 'center',
  } as ViewStyle,
  buttonContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  } as ViewStyle,
  imgContainer: {
    width: 130,
    height: 130,
    alignSelf: 'center',
  } as ViewStyle,
  border: {
    height: 1,
    width: '100%',
    backgroundColor: 'DISABLED_GREY',
    marginTop: 16,
  } as BoxProps,
}
